import { Shield, Lock, Eye, FileText, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

const PoliticaPrivacidade = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border/50 bg-card/30 backdrop-blur-xl sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/">
            <img src="/logo.png" alt="Coddar Logo" className="h-11 w-auto" />
          </Link>
          <nav className="hidden md:flex gap-6">
            <Link to="/#servicos" className="text-muted-foreground hover:text-primary transition-colors">
              Serviços
            </Link>
            <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
              Blog
            </Link>
            <Link to="/seguranca-digital" className="text-muted-foreground hover:text-primary transition-colors">
              Segurança Digital
            </Link>
            <Link to="/contato" className="text-muted-foreground hover:text-primary transition-colors">
              Contato
            </Link>
          </nav>
          <Button asChild variant="outline" className="border-primary/50 text-primary hover:bg-primary/10">
            <a href="https://folio.app.br/area-cliente">Área do Cliente</a>
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
              <Shield className="h-8 w-8 text-primary" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              Política de Privacidade
            </h1>
            <p className="text-muted-foreground">
              Última atualização: 15 de novembro de 2024
            </p>
          </div>

          {/* Conteúdo */}
          <div className="space-y-8">
            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <FileText className="h-5 w-5 text-primary" />
                  1. Informações que Coletamos
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  A Coddar coleta informações que você nos fornece diretamente, como nome, e-mail, telefone e
                  informações da empresa quando você:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Preenche formulários de contato</li>
                  <li>Solicita orçamentos ou informações</li>
                  <li>Assina nossa newsletter</li>
                  <li>Utiliza nossos serviços</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Lock className="h-5 w-5 text-primary" />
                  2. Como Usamos suas Informações
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>Utilizamos as informações coletadas para:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Responder suas solicitações e fornecer suporte</li>
                  <li>Enviar informações sobre nossos serviços</li>
                  <li>Melhorar nossos produtos e serviços</li>
                  <li>Cumprir obrigações legais e regulatórias</li>
                  <li>Enviar comunicações de marketing (com seu consentimento)</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Shield className="h-5 w-5 text-primary" />
                  3. Proteção de Dados
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações
                  pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
                </p>
                <p>
                  Seus dados são armazenados em servidores seguros e o acesso é restrito apenas a funcionários
                  autorizados que precisam dessas informações para realizar suas funções.
                </p>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Eye className="h-5 w-5 text-primary" />
                  4. Compartilhamento de Informações
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros para fins de
                  marketing. Podemos compartilhar informações apenas:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Com seu consentimento explícito</li>
                  <li>Para cumprir obrigações legais</li>
                  <li>Com prestadores de serviços que nos auxiliam (sob acordos de confidencialidade)</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle>5. Seus Direitos</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>De acordo com a LGPD, você tem direito a:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Acessar seus dados pessoais</li>
                  <li>Corrigir dados incompletos ou desatualizados</li>
                  <li>Solicitar a exclusão de seus dados</li>
                  <li>Revogar consentimento</li>
                  <li>Solicitar portabilidade dos dados</li>
                </ul>
                <p className="mt-4">
                  Para exercer seus direitos, entre em contato conosco através do e-mail:
                  <a href="mailto:privacidade@coddar.com.br" className="text-primary hover:underline ml-1">
                    privacidade@coddar.com.br
                  </a>
                </p>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle>6. Cookies</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  Utilizamos cookies e tecnologias similares para melhorar sua experiência em nosso site,
                  analisar o tráfego e personalizar conteúdo. Você pode configurar seu navegador para recusar
                  cookies, mas isso pode afetar algumas funcionalidades do site.
                </p>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle>7. Alterações nesta Política</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre mudanças
                  significativas através do nosso site ou por e-mail. Recomendamos que você revise esta página
                  regularmente.
                </p>
              </CardContent>
            </Card>

            <Card className="border-border/50 bg-card/50">
              <CardHeader>
                <CardTitle>8. Contato</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground">
                <p>
                  Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados,
                  entre em contato:
                </p>
                <div className="space-y-2 mt-4">
                  <p><strong>E-mail:</strong> privacidade@coddar.com.br</p>
                  <p><strong>Telefone:</strong> (11) 99999-9999</p>
                  <p><strong>Endereço:</strong> São Paulo, SP</p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
              <ArrowRight className="h-4 w-4 rotate-180" />
              Voltar para Home
            </Link>
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors">
              <Sparkles className="h-5 w-5" />
              <Link to="/contato">Estamos aqui para ajudar</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PoliticaPrivacidade;
